(function() {
  // 1. ÉP BẬT LOADING NGAY LẬP TỨC KHI TÌM THẤY ELEMENT
  function enablePriceLoading() {
    const priceLists = document.querySelectorAll('.hdt-price__list[bss-b2b-product-id]');
    priceLists.forEach(el => {
      el.classList.add('is-loading');
    });
  }

  // Chạy ngay lập tức để chặn trước khi app kịp render xong
  enablePriceLoading();
  
  // Chạy lại khi DOM đã sẵn sàng để đảm bảo không sót element nào (như ở trang danh mục)
  document.addEventListener("DOMContentLoaded", enablePriceLoading);

  // 2. CHỜ APP BSS XỬ LÝ XONG THÌ TẮT LOADING
  // App BSS B2B thường bắn ra một Custom Event sau khi cập nhật giá xong.
  // Chúng ta sẽ lắng nghe các event phổ biến của các app B2B Shopify.
  const b2bEvents = ['bss-b2b-variant-changed', 'bss-b2b-price-updated', 'ajaxProductPriceUpdated'];
  
  b2bEvents.forEach(eventName => {
    document.addEventListener(eventName, function() {
      removePriceLoading();
    });
  });

  // 3. PHƯƠNG ÁN DỰ PHÒNG THÔNG MINH (MutationObserver)
  // Nếu app không bắn event, ta sẽ theo dõi khi nào thuộc tính bss-b2b-product-active đổi trạng thái
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes" && mutation.attributeName === "bss-b2b-product-active") {
        removePriceLoading();
      }
    });
  });

  // Bắt đầu theo dõi khung chứa giá
  const targetNode = document.body;
  observer.observe(targetNode, { attributes: true, childList: true, subtree: true, attributeFilter: ['bss-b2b-product-active'] });

  function removePriceLoading() {
    const priceLists = document.querySelectorAll('.hdt-price__list.is-loading');
    priceLists.forEach(el => {
      // Delay nhẹ 200ms nhìn cho mượt mà
      setTimeout(() => {
        el.classList.remove('is-loading');
      }, 200);
    });
  }

  // Khóa an toàn: Tự động tắt loading sau 2.5 giây nếu app B2B bị lỗi/không chạy để khách vẫn mua được hàng
  setTimeout(removePriceLoading, 2500);
})();

(function() {
  const selector = '[data-bakeyy24-cart-status]';
  const thresholdDefault = 250000;
  let refreshTimer = null;

  function parseMoneyToCents(text) {
    const matches = String(text || '').match(/[0-9][0-9,]*(?:\.[0-9]{1,2})?/g);
    if (!matches || !matches.length) return null;
    const value = Number.parseFloat(matches[matches.length - 1].replace(/,/g, ''));
    if (!Number.isFinite(value)) return null;
    return Math.round(value * 100);
  }

  function isVisible(element) {
    if (!element) return false;
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  }

  function readDisplayedCartTotal(root) {
    const scope = root.closest('#CartDrawer, #MainCart') || document;
    const candidates = [
      '[data-cart-subtotal]',
      '[data-er-cart-total-price]',
      '[bss-b2b-cart-subtotal-price]',
      '[bss-b2b-cart-total-price]',
      '[ref="cartTotal"] .hdt-money',
      '[ref="cartTotal"]'
    ];

    for (const cartSelector of candidates) {
      const nodes = Array.from(scope.querySelectorAll(cartSelector)).filter(isVisible);
      for (const node of nodes) {
        const cents = parseMoneyToCents(node.textContent || node.getAttribute('value'));
        if (cents !== null) return cents;
      }
    }

    return null;
  }

  function hasBssCartTotal(root) {
    const scope = root.closest('#CartDrawer, #MainCart') || document;
    return Boolean(scope.querySelector('[bss-b2b-cart-total-price], [bss-b2b-cart-subtotal-price]'));
  }

  function updateStatuses(total, itemCount) {
    document.querySelectorAll(selector).forEach((status) => {
      const threshold = Number(status.dataset.bakeyy24Threshold || thresholdDefault);
      const displayedTotal = readDisplayedCartTotal(status);
      const bssTotalPending = displayedTotal == null && hasBssCartTotal(status);
      const effectiveTotal = bssTotalPending ? null : (displayedTotal == null ? Number(total || 0) : displayedTotal);
      const deliveryLabel = status.dataset.bakeyy24DeliveryLabel || 'Get it by tomorrow';
      const title = status.querySelector('[data-bakeyy24-cart-title]');
      const subtext = status.querySelector('[data-bakeyy24-cart-subtext]');
      const logout = status.querySelector('[data-bakeyy24-logout]');

      if (!title || !subtext) return;

      if (!Number.isFinite(effectiveTotal)) {
        title.textContent = 'Checking order minimum';
        if (logout) logout.hidden = true;
        subtext.textContent = 'Minimum order \u20b92,500';
        status.classList.remove('is-eligible', 'is-ineligible');
        scheduleRefresh(350);
        return;
      }

      status.dataset.bakeyy24CartTotal = String(effectiveTotal);
      const eligible = itemCount > 0 && effectiveTotal >= threshold;

      status.classList.toggle('is-eligible', eligible);
      status.classList.toggle('is-ineligible', itemCount > 0 && !eligible);

      if (itemCount <= 0) {
        title.textContent = 'Bakeyy24 pricing active';
        if (logout) logout.hidden = true;
        subtext.textContent = 'Minimum order \u20b92,500';
      } else if (eligible) {
        title.textContent = deliveryLabel;
        subtext.textContent = 'Eligible to checkout with Bakeyy24 benefits';
        if (logout) logout.hidden = true;
      } else {
        title.textContent = 'Not eligible for Bakeyy24 benefits';
        if (logout) logout.hidden = false;
        subtext.textContent = 'Your cart is below \u20b92,500.';
      }
    });
  }

  function refreshStatuses() {
    if (!document.querySelector(selector)) return;

    fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then((response) => response.ok ? response.json() : Promise.reject())
      .then((cart) => {
        updateStatuses(Number(cart.total_price || 0), Number(cart.item_count || 0));
      })
      .catch(() => {
        document.querySelectorAll(selector).forEach((status) => {
          const total = readDisplayedCartTotal(status);
          updateStatuses(total, 1);
        });
      });
  }

  function scheduleRefresh(delay) {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshStatuses, delay || 120);
  }

  document.addEventListener('DOMContentLoaded', () => scheduleRefresh(0));
  document.addEventListener('cart:update', () => scheduleRefresh(180));
  document.addEventListener('cart:reload', () => scheduleRefresh(180));
  document.addEventListener('bss-b2b-price-updated', () => scheduleRefresh(120));
  document.addEventListener('ajaxProductPriceUpdated', () => scheduleRefresh(120));
  document.addEventListener('change', (event) => {
    if (event.target && event.target.matches('input[name="quantity"], .hdt-quantity__input')) {
      scheduleRefresh(450);
    }
  }, true);
  document.addEventListener('click', (event) => {
    if (event.target && event.target.closest('cart-remove-button, .hdt-quantity__button')) {
      scheduleRefresh(450);
    }
  }, true);

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => {
      if (mutation.type === 'attributes' && mutation.target?.matches?.('[bss-b2b-cart-total-price], [bss-b2b-cart-subtotal-price]')) {
        return true;
      }

      return Array.from(mutation.addedNodes).some((node) => node.nodeType === 1 && (node.matches?.(selector) || node.querySelector?.(selector)));
    })) {
      scheduleRefresh(120);
    }
  });

  if (document.body) {
    observer.observe(document.body, { attributes: true, attributeFilter: ['style'], childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', () => observer.observe(document.body, { attributes: true, attributeFilter: ['style'], childList: true, subtree: true }), { once: true });
  }
})();

(function() {
  function hideLegacyBangalorePills() {
    if (!document.querySelector('[data-bakeyy24-status]')) return;

    document.querySelectorAll('body *:not(script):not(style)').forEach((element) => {
      if (element.dataset.bakeyy24LegacyHidden === 'true') return;

      const text = (element.textContent || '').trim();
      if (!text.includes('Bangalore Priority Pricing Active')) return;
      if (text.length > 80 || element.childElementCount > 4) return;

      element.dataset.bakeyy24LegacyHidden = 'true';
      element.hidden = true;
    });
  }

  document.addEventListener('DOMContentLoaded', hideLegacyBangalorePills);
  document.addEventListener('bss-b2b-price-updated', hideLegacyBangalorePills);
  document.addEventListener('ajaxProductPriceUpdated', hideLegacyBangalorePills);

  const observer = new MutationObserver(hideLegacyBangalorePills);
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', () => observer.observe(document.body, { childList: true, subtree: true }), { once: true });
  }
})();
